import FrozenVegsFruitsProduct from 'models/FrozenVegsFruitsProduct'

export const packagingInitialState = {
  category: FrozenVegsFruitsProduct.category,
  subCategory: FrozenVegsFruitsProduct.subCategory,
  ItemType: {
    value: '',
    label: 'Type',
  },
  Size: '',
  PackageType: {
    value: '',
    label: 'Package Type',
  },
  FrozenPackageCertification: false,
  OrganicVerification: false,
  FrozenProductType: 'Fruit',
  otherType: '',
  otherPackageType: '',
}

export const productTypeOptions = ['Fruit', 'Vegetable']

export const fruitTypeOptions = [
  {
    value: '',
    label: 'Fruit Type',
    isDisabled: true,
  },
  { value: 'Apple', label: 'Apple' },
  { value: 'Apricot', label: 'Apricot' },
  { value: 'Banana', label: 'Banana' },
  { value: 'Berry, Mixed', label: 'Berry, Mixed' },
  { value: 'Blackberry', label: 'Blackberry' },
  { value: 'Blueberry', label: 'Blueberry' },
  { value: 'Cantaloupe', label: 'Cantaloupe' },
  { value: 'Cherry', label: 'Cherry' },
  { value: 'Chili', label: 'Chili' },
  { value: 'Clementine', label: 'Clementine' },
  { value: 'Cranberry', label: 'Cranberry' },
  { value: 'Currant', label: 'Currant' },
  { value: 'Date', label: 'Date' },
  { value: 'Fig', label: 'Fig' },
  { value: 'Fruit, Mixed', label: 'Fruit, Mixed' },
  { value: 'Grapefruit', label: 'Grapefruit' },
  { value: 'Grape', label: 'Grape' },
  { value: 'Guava', label: 'Guava' },
  { value: 'Kiwi', label: 'Kiwi' },
  { value: 'Lemon', label: 'Lemon' },
  { value: 'Lime', label: 'Lime' },
  { value: 'Mango', label: 'Mango' },
  { value: 'Mulberry', label: 'Mulberry' },
  { value: 'Nectarine', label: 'Nectarine' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Papaya', label: 'Papaya' },
  { value: 'Passionfruit', label: 'Passionfruit' },
  { value: 'Peach', label: 'Peach' },
  { value: 'Peacharine', label: 'Peacharine' },
  { value: 'Pear', label: 'Pear' },
  { value: 'Pepper', label: 'Pepper' },
  { value: 'Pineapple', label: 'Pineapple' },
  { value: 'Plum', label: 'Plum' },
  { value: 'Pluot', label: 'Pluot' },
  { value: 'Pomegranate', label: 'Pomegranate' },
  { value: 'Prune', label: 'Prune' },
  { value: 'Raisin', label: 'Raisin' },
  { value: 'Raspberry', label: 'Raspberry' },
  { value: 'Strawberry', label: 'Strawberry' },
  { value: 'Tangelo', label: 'Tangelo' },
  { value: 'Tangerine', label: 'Tangerine' },
  { value: 'Watermelon', label: 'Watermelon' },
  { value: 'Youngberry', label: 'Youngberry' },
  {
    value: 'Other',
    label: 'Other',
  },
]

export const vegTypeOptions = [
  {
    value: '',
    label: 'Vegetable Type',
    isDisabled: true,
  },
  { value: 'Artichoke', label: 'Artichoke' },
  { value: 'Asparagus', label: 'Asparagus' },
  { value: 'Avocado', label: 'Avocado' },
  { value: 'Bamboo', label: 'Bamboo' },
  { value: 'Beanette', label: 'Beanette' },
  { value: 'Bean, Green', label: 'Bean, Green' },
  { value: 'Bean, Lima', label: 'Bean, Lima' },
  { value: 'Bean, Other', label: 'Bean, Other' },
  { value: 'Beet', label: 'Beet' },
  { value: 'Blackeye Pea', label: 'Blackeye Pea' },
  { value: 'Broccoflower', label: 'Broccoflower' },
  { value: 'Broccoli', label: 'Broccoli' },
  { value: 'Brussels Sprout', label: 'Brussels Sprout' },
  { value: 'Cabbage', label: 'Cabbage' },
  { value: 'Carrot', label: 'Carrot' },
  { value: 'Cauliflower', label: 'Cauliflower' },
  { value: 'Celery', label: 'Celery' },
  { value: 'Chili', label: 'Chili' },
  { value: 'Chive', label: 'Chive' },
  { value: 'Choy', label: 'Choy' },
  { value: 'Corn', label: 'Corn' },
  { value: 'Cress', label: 'Cress' },
  { value: 'Cucumber', label: 'Cucumber' },
  { value: 'Eggplant', label: 'Eggplant' },
  { value: 'Endive', label: 'Endive' },
  { value: 'Garlic', label: 'Garlic' },
  { value: 'Gourd', label: 'Gourd' },
  { value: 'Green', label: 'Green' },
  { value: 'Hominy', label: 'Hominy' },
  { value: 'Leek', label: 'Leek' },
  { value: 'Mixed Vegetable', label: 'Mixed Vegetable' },
  { value: 'Mushroom', label: 'Mushroom' },
  { value: 'Okra', label: 'Okra' },
  { value: 'Onion', label: 'Onion' },
  { value: 'Pea', label: 'Pea' },
  { value: 'Pea, Sugar Snap', label: 'Pea, Sugar Snap' },
  { value: 'Pepper', label: 'Pepper' },
  { value: 'Pumpkin', label: 'Pumpkin' },
  { value: 'Radish', label: 'Radish' },
  { value: 'Rhubarb', label: 'Rhubarb' },
  { value: 'Spinach', label: 'Spinach' },
  { value: 'Sprout', label: 'Sprout' },
  { value: 'Squash', label: 'Squash' },
  { value: 'Sweet Potato', label: 'Sweet Potato' },
  { value: 'Tomato', label: 'Tomato' },
  { value: 'Watercress', label: 'Watercress' },
  { value: 'Zucchini', label: 'Zucchini' },
  {
    value: 'Other',
    label: 'Other',
  },
]


export const packageTypeOptions = [
  {
    value: '',
    label: 'Package Type',
    isDisabled: true,
  },
  {
    value: 'Bag',
    label: 'Bag',
  },
  {
    value: 'Box',
    label: 'Box',
  },
  {
    value: 'Other',
    label: 'Other',
  },
]
